import Client from './client';

export default class ShopifyLocalizedVariants extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getExperienceAndMapByExperienceKey(organization, experienceKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/shopify/localized/variants/experience/${experienceKey}/map`, options);
  }

}
